import { LayoutSingleColumn, Modal, Page, PrimaryButton } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './GiftCardPage.module.css';
import Footer from '../../components/Footer/FooterNew';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import RevolutForm from '../CheckoutPage/RevolutForm/RevolutForm';
import NamedLinkNewTab from '../../components/NamedLink/NamedLinkNewTab';
import { post } from '../../util/api';
import { useHistory, useParams } from 'react-router';
import axios from 'axios';

import { FormattedMessage, useIntl } from 'react-intl';
import GiftCardComponent from './giftcardPrintable';
import { sendCustomEmail } from '../../util/sendEmails';
import { getEmailBody } from './giftcardEmailBodyPayload';

const giftcardEN =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082484/socialbnb/assets/giftcardPage/giftcard-en.avif';

const giftcardDE =
  'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082483/socialbnb/assets/giftcardPage/giftcard-de.avif';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const GiftCardPageComponent = props => {
  const [forFriend, setforFriend] = useState(false);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [friendFullName, setFriendFullName] = useState('');
  const [friendEmail, setFriendEmail] = useState('');
  const [occasion, setOccasion] = useState('');
  const [amount, setAmount] = useState(10);
  const [friendEmailPrep, setFriendEmailPrep] = useState('');
  const [error, setError] = useState(false);
  const [canPay, setCanPay] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const [completedGiftCard, setCompletedGiftCard] = useState(null);
  const [paypalAmount, setPaypalAmount] = useState(0);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [image, setImage] = useState(<img src={giftcardEN} className={css.img} />);
  const history = useHistory();
  const intl = useIntl();
  const { lang } = useParams();

  useEffect(() => {
    if (
      amount !== '' &&
      amount > 9 &&
      amount < 1000 &&
      (!forFriend || (forFriend && friendFullName.length > 0)) &&
      (!forFriend || emailRegex.test(friendEmail)) &&
      (forFriend || emailRegex.test(email)) &&
      (forFriend || fullName.length > 0)
    ) {
      setCanPay(true);
    } else {
      setCanPay(false);
    }
    setPaypalAmount(Number(amount));
    setFriendEmailPrep(friendEmail);
    if (amount < 10 || amount > 999) {
      setAmountError(true);
    } else {
      setAmountError(false);
    }
  }, [friendEmail, friendFullName, amount, forFriend, email, fullName]);

  useEffect(() => {
    if (intl.locale == 'en') {
      setImage(<img src={giftcardEN} className={css.img} />);
    } else {
      setImage(<img src={giftcardDE} className={css.img} />);
    }
  }, [intl.locale]);

  const handlePaymentCapture = result => {
    setIsloading(true);
    // Handle Revolut payment
    if (result?.revolut?.orderId) {
      const revolutOrderId = result?.revolut?.orderId;
      const giftCardAmount = Number(amount);
      const finalMessage =
        occasion.length > 2
          ? occasion
          : lang == 'en'
          ? 'Your New Gift Card!'
          : 'Dein neuer Reisegutschein';
      const purchaserEmail = email;
      let bodyData = forFriend
        ? {
            amount: giftCardAmount,
            clientEmail: purchaserEmail,
            friendEmail: friendEmail,
          }
        : {
            amount: giftCardAmount,
            clientEmail: purchaserEmail,
          };
      post('/api/discount/create', bodyData)
        .then(resp => {
          let emailBody = `New Giftcard Generated by a client : \n Creator email: ${purchaserEmail} for ${
            forFriend ? friendEmail : purchaserEmail
          }, Amount: ${resp?.fixedAmount}, Code: ${
            resp?.code
          }, Revolut Order Id : ${revolutOrderId}`;
          axios
            .post(
              'https://api.emailjs.com/api/v1.0/email/send-form/',
              new URLSearchParams({
                service_id: 'service_eyyf7wt',
                template_id: 'template_xp25qbb',
                user_id: '2LPtLKMfxBjA4y7c9',
                message: emailBody,
              })
            )
            .then(response => {})
            .catch(e => console.log('Error ', e));
          setCompletedGiftCard({
            amount: resp.fixedAmount,
            giftCode: resp.code,
            expiration: resp.Expiration,
            recipientName:
              forFriend && friendFullName.length > 1 ? friendFullName : fullName,
            senderName: fullName,
            message: finalMessage,
          });
          setIsloading(false);
          setModalOpen(true);
          resetForm();
          sendCustomEmail(
            purchaserEmail,
            lang == 'en' ? 'Your Gift card' : 'Reisegutschein',
            getEmailBody(lang, finalMessage, resp?.Expiration, resp?.fixedAmount, resp?.code)
          );
        })
        .catch(e => {
          console.log(e);
          setIsloading(false);
          setError(true);
        });
    } else {
      setIsloading(false);
    }
  };

  const resetForm = () => {
    setforFriend(false);
    setFullName('');
    setEmail('');
    setFriendFullName('');
    setFriendEmail('');
    setOccasion('');
    setAmount(10);
    setFriendEmailPrep('');
    setError(false);
    setCanPay(false);
    setAmountError(false);
  };

  const changeVal = target => {
    setError(false);
    let val = target.value;
    switch (target.id) {
      case 'amount':
        setAmount(val === '' ? '' : Number(val));
        break;
      case 'friendName':
        setFriendFullName(val);
        break;
      case 'friendEmail':
        setFriendEmail(val);
        break;
      case 'occasion':
        setOccasion(val);
        break;
      case 'fullName':
        setFullName(val);
        break;
      case 'email':
        setEmail(val);
        break;
    }
  };

  const termsLink = (
    <NamedLinkNewTab name="CMSPage" params={{ pageId: 'agb' }}>
      <FormattedMessage id="AuthenticationPage.termsAndConditionsTermsLinkText" />
    </NamedLinkNewTab>
  );

  const termsAndConditions = (
    <div className={css.termsAndConditions}>
      <input
        type="checkbox"
        id="terms"
        checked={termsAccepted}
        onChange={() => setTermsAccepted(!termsAccepted)}
        data-elbaction="click:click termsAndConditions"
      />
      <label htmlFor="terms" style={{ padding: 0, margin: 0 }}>
        {intl.formatMessage({ id: 'PaymentForm.termsAndConditionsAcceptText' }, { termsLink })}
      </label>
    </div>
  );
  return (
    <Page
      title={intl.formatMessage({ id: 'giftcardPage.title' })}
      keywords={intl.formatMessage({ id: 'giftcardPage.keywords' })}
      description={intl.formatMessage({ id: 'giftcardPage.desc' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'Product',
        name: 'socialbnb Gift Card',
        url: `https://socialbnb.org/${intl?.locale || 'en'}/giftcard`,
        image: intl?.locale === 'en' ? giftcardEN : giftcardDE,
        offers: {
          '@type': 'Offer',
          url: `https://socialbnb.org/${intl?.locale || 'en'}/giftcard`,
          priceCurrency: 'EUR',
          price: amount,
          eligibleRegion: {
            '@type': 'Place',
            name: intl?.locale === 'de' ? 'Germany' : 'International',
          },
        },
        brand: {
          '@type': 'Organization',
          name: 'socialbnb',
          url: 'https://socialbnb.org',
        },
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<Footer />}>
        <h1 className={css.pageTitle}>
          <FormattedMessage id="giftcardPage.header" />{' '}
        </h1>
        <div
          className={css.container}
          data-elbglobals="pagetype:giftcardpage"
          data-elbaction="visible:vis giftpage-purchase-section"
        >
          <Modal
            isOpen={modalOpen}
            onClose={() => {
              setModalOpen(false);
              setCompletedGiftCard(null);
            }}
          >
            <div className={css.modalContainer}>
              <h3 className={css.modalTextHeader}>
                {' '}
                <FormattedMessage id="giftcardPage.successModalTitle" />
              </h3>
              <div className={css.modalText}>
                <FormattedMessage id="giftcardPage.successModal" />
                <div className={css.spamMessage}>
                  <FormattedMessage id="giftcardPage.checkSpamMessage" />
                </div>
              </div>
              <div className={css.printFieldContainer}>
                <GiftCardComponent
                  recipientName={completedGiftCard?.recipientName}
                  senderName={completedGiftCard?.senderName}
                  message={completedGiftCard?.message}
                  amount={completedGiftCard?.amount}
                  giftCode={completedGiftCard?.giftCode}
                  expirationDate={completedGiftCard?.expiration}
                  lang={lang}
                />
              </div>
              <PrimaryButton
                onClick={() => {
                  history.push(`/${lang}/s`);
                }}
              >
                <FormattedMessage id="giftcardPage.modalButton" />
              </PrimaryButton>
            </div>
          </Modal>
          <div className={css.content}>
            <div className={css.createForm}>
              <div className={css.formeForm}>
                <div className={css.friendDetails}>
                  <div className={css.field}>
                    <p>
                      {' '}
                      <FormattedMessage id="giftcardPage.yourName" />
                    </p>
                    <input
                      placeholder="Nils"
                      id="fullName"
                      value={fullName}
                      onChange={e => {
                        changeVal(e.target);
                      }}
                    />
                  </div>
                  <div className={css.field} data-elbaction="click:click giftpage-email-input">
                    <p>
                      {' '}
                      <FormattedMessage id="giftcardPage.YourEmail2" />
                    </p>
                    <input
                      placeholder="example@email.com"
                      id="email"
                      value={email}
                      onChange={e => {
                        changeVal(e.target);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className={css.friendForm}>
                <div className={css.friendDetails}>
                  <div className={css.field}>
                    <p>
                      {' '}
                      <FormattedMessage id="giftcardPage.YourFriendName" />{' '}
                    </p>
                    <input
                      placeholder="Alexander"
                      id="friendName"
                      value={friendFullName}
                      onChange={e => {
                        changeVal(e.target);
                      }}
                    />
                  </div>
                  <div className={css.field}></div>
                </div>
                <div className={css.fieldOccasion}>
                  <p>
                    {' '}
                    <FormattedMessage id="giftcardPage.personnalMessage" />{' '}
                  </p>
                  <input
                    placeholder={intl.formatMessage({
                      id: 'giftcardPage.personnalMessagePlaceHolder',
                    })}
                    id="occasion"
                    value={occasion}
                    onChange={e => {
                      changeVal(e.target);
                    }}
                    className={css.occasionStyle}
                  />
                </div>
              </div>
              <div className={css.amount}>
                <div className={css.field}>
                  <p className="">
                    {' '}
                    <FormattedMessage id="giftcardPage.amount" />{' '}
                  </p>
                  <div className={css.amountField}>
                    <input
                      type="number"
                      placeholder="Amount"
                      id="amount"
                      value={amount}
                      max="100"
                      onChange={e => {
                        changeVal(e.target);
                      }}
                    />{' '}
                    <span className={css.euroSign}> € </span>
                  </div>
                  {amountError ? (
                    <div className={css.error}>
                      <FormattedMessage id="giftcardPage.amountError" />
                    </div>
                  ) : null}
                </div>
                <div className={css.field}></div>
              </div>
              <div className={css.paypalForm} data-elbaction="click:click giftpage-payment">
                <div className={css.field}>
                  {!isLoading &&
                  canPay &&
                  paypalAmount == amount &&
                  friendEmailPrep == friendEmail ? (
                    <div className={css.paypalScript}>
                      <RevolutForm
                        amount={paypalAmount * 100}
                        basePrice={paypalAmount * 100}
                        callbackFunction={data => {
                          setIsloading(true);
                          handlePaymentCapture(data);
                        }}
                        termsAndConditions={{ component: termsAndConditions, termsAccepted }}
                        isEarlyExperienceBooking={false}
                        isSecondPayment={true}
                        paymentDescription={intl.formatMessage({ id: 'giftcardPage.paymentDescription' })}
                        isGiftCard={true}
                      />
                    </div>
                  ) : null}
                  {isLoading ? (
                    <div className={css.LoadingDiv}>
                      <div className={css.loadingContainer}>
                        <div className={css.loading}></div>
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className={css.field}></div>
              </div>
              {error ? (
                <div className={css.error}>
                  <FormattedMessage id="PayoutDetailsForm.createStripeAccountFailed" />
                </div>
              ) : null}
            </div>
            <div className={css.imageContainer}>{image}</div>
          </div>
          <div className={css.bottomNote}>
            <FormattedMessage id="giftcardPage.bottomNote1" />
            <a href={intl.formatMessage({ id: 'giftcardPage.formlLink' })} className={css.formLink}>
              <FormattedMessage id="giftcardPage.bottomNote2" />{' '}
            </a>
            <FormattedMessage id="giftcardPage.bottomNote3" />
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return { currentUser };
};

const GiftCardPage = compose(withRouter, connect(mapStateToProps))(GiftCardPageComponent);

export default GiftCardPage;
